/* eslint:disable */
/**
 * Correct Date.parse compliant regex to validate if a date string is in ISO 8610 format
 * Complete time HH:mm:ss is required. Timezone is required, either as `Z` or `+/-(HH:mm)`.
 * Supports gregorian calendar. Handles leap years.
 * 
 * Examples of valid date strings:
 * 
 * 
 * 2015-01-17T18:23:02+06:45
 * 
 * 2015-01-17T18:23:02Z
 * 
 * 2015-01-17T18:23:02-00:00 
 * 
 */
// eslint-disable-next-line max-len
export const REGEX_ISO8601_DATEFORMAT = /^(?:[1-9]\d{3}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1\d|2[0-8])|(?:0[13-9]|1[0-2])-(?:29|30)|(?:0[13578]|1[02])-31)|(?:[1-9]\d(?:0[48]|[2468][048]|[13579][26])|(?:[2468][048]|[13579][26])00)-02-29)T(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(\.\d{1,3})?(?:Z|[+-][01]\d:[0-5]\d)$/;

/**
 * Matches if the format is ISO JSON date, timezone-less ISO 8610. e.g 
 * 
 * `2012-12-22T00:00:00`
 * 
 * `2012-12-22T00:00:00.544`
 * 
 * NOTE that any date string in this format will be constructed as a UTC date by JavaScript Date constructor
 * and must thus be normalized to flip
 * this into a locale date.
 *
 */
// eslint-disable-next-line max-len
export const REGEX_ISO8601_NO_TZ = /^(?:[1-9]\d{3}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1\d|2[0-8])|(?:0[13-9]|1[0-2])-(?:29|30)|(?:0[13578]|1[02])-31)|(?:[1-9]\d(?:0[48]|[2468][048]|[13579][26])|(?:[2468][048]|[13579][26])00)-02-29)T(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(\.\d{1,3})?$/;

/**
 * Matches if the format is JSON ISO date without the time part, e.g
 * 
 * `20012-12-22`
 */
// eslint-disable-next-line max-len
export const REGEX_ISO8691_NO_TIME_PART = /^(?:[1-9]\d{3}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1\d|2[0-8])|(?:0[13-9]|1[0-2])-(?:29|30)|(?:0[13578]|1[02])-31)|(?:[1-9]\d(?:0[48]|[2468][048]|[13579][26])|(?:[2468][048]|[13579][26])00)-02-29)/;

const FORMAT_ISO_8601_DATE = 'yyyy-MM-dd';

/* eslint:enable */
/**
 * Validates if a user input string contains both year, month and day in positions defined by the formatString argument.
 * 
 * The separator char is ignored and may be any non-numeric character,
 * 
 *  such as `-`, `/`, `.`
 * 
 * Can be used to validate if the string can be parsed into a valid Date object with time part set to 00.
 * 
 * If no format is given, then ISO yyyy-MM-dd is assumed
 * 
 * @example
 * 
 * `
 * isValidDateString('2012-12-24') // returns true
 * 
 * isValidDateString('2012-24-12', 'yyyy-dd-MM') // returns true
 * 
 * isValidDateString('24/12/2012', 'dd-MM-yyyy') // returns true, separator char is ignored
 * `
 */
export function isValidDateString(dateString: string, formatString: string = FORMAT_ISO_8601_DATE ) {
  try{
    const format = formatString.split(/\W/);
    const date = dateString.split('T')[0].split(/\W/);
    //console.log(format);
    let m: any;
    let d: any;
    let y: any;

    for (let i = 0, len = format.length; i < len; i++) { //eslint:disable-line
      if (/[Mm]/.test(format[i])) {
        m = Number(date[i]);
      } else if (/[Dd]/.test(format[i])) {
        d = Number(date[i]);
      } else if (/[Yy]/.test(format[i])) {
        y = Number(date[i]);
      }
    }
    //console.log(y, m, d);
    return (m > 0 && m < 13 && y && y > 1970 && d > 0 && d <= new Date(y, m, 0).getDate()) === true;

  }catch (e){
    return false;
  }
}
